import '../DeckNav.css';
import { PeopleDeckFace , BasicsDeckFace , EverydayDeckFace, WorldDeckFace} from '../../DeckCardOverviews/BasicWords/BasicWordsOv';
import DeckNav from '../DeckNav';
import HeaderNav from '../../Components/Header/Header_Nav/Header_Nav';
//one folder up so use ../
//if two folders away use ../../
import SPLoader from '../../Components/Spinner/SpinnerLoader';
import Footer from '../../Components/Footer/Footer';


export default function BasicWordsNav() {
  return (
<div>
  <SPLoader time={1.2}/>
  <HeaderNav GoBack_to={"/"}/>
   <div><DeckNav faceCard={BasicsDeckFace} title_input="Basics"/> </div>
   <div><DeckNav faceCard={PeopleDeckFace} title_input="People"/> </div>
    <div><DeckNav faceCard={EverydayDeckFace} title_input="Everyday Life"/> </div>
    <div><DeckNav faceCard={WorldDeckFace} title_input="The World Around Us"/> </div>
    <Footer/>
</div>
  )
}